import React, { Component } from "react";
import classes from "./ARCCollections.module.css";
import axios from "../../../../axios-order";
import ErrorIcon from "@material-ui/icons/Error";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Card from "../../../../components/ui/Cards";
import PublishIcon from "@material-ui/icons/Publish";
import GetAppIcon from "@material-ui/icons/GetApp";
import DataTables from "material-ui-datatables";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import SellerCollection from "../../../../asserts/templates/vendor_payment.xlsx";
import ClearIcon from "@material-ui/icons/Clear";
import { ValidatorForm } from "react-material-ui-form-validator";
import CircularProgress from "@material-ui/core/CircularProgress";
import ValidatedDatePicker from "../../../../components/ui/DatePicker";
import { toast } from "react-toastify";
import TextField from "@material-ui/core/TextField";
import CustomTable from "../../../../components/ui/Table/Table";
import moment from "moment";
import { TablePagination } from "@material-ui/core";
import BoxWrapper from "../../../../components/ui/boxWrapper";
import RefreshIcon from "@mui/icons-material/Refresh";
import ToggleSwitch from "../../../../components/ui/ToggleSwitch/ToggleSwitch";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import RightDrawer from "../../../../components/ui/RightDrawer";
import ZohoModel from "../../../../components/ZohoModel/ZohoModel";
import ErpConnectorModel from "../../../../components/ZohoModel/ErpConnector";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { withRouter } from 'react-router-dom';
import { canWrite } from "../../../../utils/privilegeUtils";
import Modal from "react-bootstrap/Modal";
import { FormControl, FormControlLabel, RadioGroup, Radio } from '@material-ui/core';
import DatePicker from '../../../../components/ui/DatePicker'

// Added for the in-grid column filter row
import TuneIcon from "@mui/icons-material/Tune";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import Chip from "@material-ui/core/Chip";

let flagForZoho = 1;
let variableForTimerForZohoInCollection = null;

// indian rupeess system---
const numberFormat = (value) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumSignificantDigits: 15,
  }).format(value);
// ---End---

const dateFormat = (value) => {
  // if (typeof value === "undefined") return false;
  if (value) {
    let old_date = String(value).split("-");
    return old_date[2] + "/" + old_date[1] + "/" + old_date[0];
  }
};

const dateFormatWithDash = (value) => {
  if (value) {
    let old_date = String(value).split("-");
    return old_date[2] + "-" + old_date[1] + "-" + old_date[0];
  }
};

const indianFormat = (date) => {
  let dateArr = date.split("-");
  return dateArr[2] + "-" + dateArr[1] + "-" + dateArr[0];
};

// Set to true AFTER BoxWrapper has been given a `headerExtra` prop (render
// {props.headerExtra} right after its search input). The Filter button then
// appears next to the Payment Details search. While false, the button is
// rendered just above the table instead, so it never disappears.
const FILTER_BUTTON_IN_BOXWRAPPER = true;

class Collections extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isExportingAll: false,
      effitracCol: [
        {
          key: "customerCode",
          render: (index, row) => {
            return row["erpVendorCode"];
          },
        },
        {
          key: "gstin",
          render: (index, row) => {
            return row["vendorGstin"];
          },
        },
        {
          key: "collectionDate",
          render: (index, row) => {
            // return dateFormatWithDash(row['collectionDate']);
            return row["collectionDate"];
          },
        },

        {
          key: "collectionAmount",
          render: (index, row) => {
            return numberFormat(row["amountPaid"]);
          },
        },

        {
          key: "collectionRefNo",
          render: (index, row) => {
            return row["collectionReferenceNumber"];
          },
        },
        {
          key: "bankAccountNo",
          render: (index, row) => {
            return row["bankAccountNumber"];
          },
        },
        // {
        //   key: 'fetrack',
        //   render: (index, row) => {
        //     return row['fetrack'];
        //   },
        // },
      ],
      effitracData: null,
      oldEffitracData: null,
      editCollectionData: {},
      editOpenDrawer: false,
      effitracHeader: [
        { label: "ERP Vendor Code" },

        { label: "GSTIN" },
        { label: "PAYMENT Date" },
        { label: "PAYMENT Amount" },

        { label: "TRANSACTION Ref No" },
        { label: "Bank Account No" },
        // { label: 'Fetrack' },
      ],

      read_only: "",
      next: {},
      prev: {},
      file_value: null,
      total_records: 0,
      errorPage: 1, // Current page
      perErrorPages: 10, // Records per page
      errortotal: 0, // Total records 
      successful_records: 0,
      error_records: 0,
      error_rows: {},
      loadingExport: false,
      sellerCustomerCol: [
        // { key: 'seller_code', label: 'Seller Code', },
        {
          label: "GSTIN",
          render: (name, all) => {
            return all["record"]["GSTIN"];
          },
        },
        {
          label: "Invoice Number",
          render: (name, all) => {
            return all["record"]["InvoiceNo"];
          },
        },
        { key: "row", label: "Row #" },
        {
          label: "Errors",
          render: (name, all) => {
            return Object.keys(all["errors_in"]).map((i, v) => {
              return (
                <div style={{ whiteSpace: "pre-wrap" }}>
                  <span>{i}</span>&nbsp;<span>:</span>&nbsp;
                  <span style={{ color: "red" }}>
                    {all["errors_in"][i].join(",")}
                  </span>
                </div>
              );
            });
          },
        },
        // {label:"Status",key:"status"}
      ],
      sellerCustomerData: [],
      error: null,

      allArcCollectionData: [],
      OriginalAllArcCollectionData: [],
      showUploadData: false,
      loading: false,

      // add collection modal
      allArcSellerCustomerData: [],
      OriginalDataAllArcSellerCustomerData: [],
      collectionModalBackDrop: false,

      //............Edited by Harsh..............
      openZohoDrawer: false,
      messageForConnection: "Establish Connection",
      buttonColor: "red",
      grantToken: "",
      url: "",
      zohoDate: {},
      autoSync: false,

      // import effitrac / tally
      openImportEffitracDrawer: false,
      effitracFetchFromData: {},
      lastUploadDate: "",

      // pagination state
      page: 0,
      rowsPerPage: 25,
      rowCount: 0,
      searchInput: "",

      // upload history table data
      uploadHistoryTableData: [],
      // showUploadHistroyTable: false,

      flagForZohoInCollection: false,
      timerForZohoInCollection: 60,
      // variableForTimerForZohoInCollection:null ,
      loader: true,
      erpConnectorModelOpen: false,
      erpConnectorName: '',
      erpDataExportLoading: false,
      importToCwsLoading: false,

      dateFilterOption: "withDateFilter",
      triggerModelFromToDate: false,
      fromPeriodDisplay: null,
      fromPeriod: null,
      toPeriodDisplay: '',
      toPeriod: null,

      // ---------------------------------------------------------------
      // IN-GRID MULTI-FIELD FILTER (same pattern as the other Data Upload
      // screens): a dedicated filter row sits directly under the sticky
      // grouped header, one compact box per column. Each box takes a
      // comma-separated "is any of" list, and every typed box is combined
      // (AND/OR) into a SINGLE apply.
      // ---------------------------------------------------------------
      // inlineFilterValues: what's currently typed into each column's box,
      // keyed by field — draft state, not yet sent to the backend.
      inlineFilterValues: {},
      // appliedFilters: the conditions actually in effect on the table.
      //   Each condition: { field, value } — value is the raw comma string.
      appliedFilters: [],
      // filterMatchType: "AND" (every filled column must match) or "OR"
      // (any filled column matching is enough).
      filterMatchType: "AND",
      // Mirrors appliedFilters into the shape sent to the backend; kept in
      // state so pagination handlers can tell "filtered" from "unfiltered".
      activeFilters: null,

      // ---------------------------------------------------------------
      // COMMON FILTER PANEL — one "Filter" button opens a compact side
      // panel next to the table (Basic filters open, Advanced collapsed).
      // "Apply Filters" commits everything in a SINGLE api call through the
      // same appliedFilters / applyDynamicFilters flow used above.
      // ---------------------------------------------------------------
      filterPanelOpen: false,
      advancedFiltersOpen: false,
      // draftValues: what is set in the panel, keyed by column key.
      draftValues: {},
    };
  }

  // ---------------------------------------------------------------------
  // COLUMNS for the Payment Details grid — one entry per key returned by
  // /get_vendor_collection_details. `group` drives the colored group-band
  // row, `width` (px) gives every header / filter box / cell a fixed size so
  // the sticky header, filter row and data all line up exactly; the table
  // scrolls horizontally instead of squeezing columns. An optional `render`
  // formats the cell value (e.g. currency for Payment Amount).
  // IMPORTANT: columns that share a group must stay next to each other in
  // these arrays, because the group band is built from consecutive columns.
  // ---------------------------------------------------------------------
  filterableColumns = [
    // Vendor
    { key: "vendorName", label: "Vendor Name", group: "Vendor", width: 240 },
    { key: "erpVendorCode", label: "ERP Vendor Code", group: "Vendor", width: 150 },
    { key: "vendorCode", label: "Vendor Code", group: "Vendor", width: 120 },
    { key: "vendorGstin", label: "GSTIN", group: "Vendor", width: 170 },
    { key: "vendorPan", label: "PAN", group: "Vendor", width: 130 },

    // Payment Details
    { key: "collectionDate", label: "Payment Date", group: "Payment Details", width: 140 },
    { key: "amountPaid", label: "Payment Amount", group: "Payment Details", width: 160, render: (row) => numberFormat(row.amountPaid) },
    { key: "collectionReferenceNumber", label: "Transaction Ref No", group: "Payment Details", width: 190 },
    { key: "bankAccountNumber", label: "Bank Account Number", group: "Payment Details", width: 180 },

    // Voucher
    { key: "voucherId", label: "Voucher ID", group: "Voucher", width: 190 },
    { key: "creditLedger", label: "Credit Ledger", group: "Voucher", width: 240 },
    { key: "group", label: "Group", group: "Voucher", width: 130 },
    { key: "billNumber", label: "Bill Number", group: "Voucher", width: 150 },
    { key: "nonCashTxnSettlement", label: "Non-cash Txn Settlement", group: "Voucher", width: 210 },
    { key: "tds_tcs_section", label: "TDS/TCS Section", group: "Voucher", width: 160 },
    { key: "flag", label: "Flag", group: "Voucher", width: 100 },

    // Other
    { key: "orgCode", label: "Org Code", group: "Other", width: 100 },
  ];

  // Trailing, display-only columns (not filterable) — still part of the
  // grouped header so the colored bands cover the full table width.
  nonFilterableColumns = [
    { key: "createDate", label: "Create Date", group: "Record Info", width: 170 },
    { key: "modifyDate", label: "Modify Date", group: "Record Info", width: 170 },
    { key: "created_date", label: "Created Date (System)", group: "Record Info", width: 190 },
    { key: "modified_date", label: "Modified Date (System)", group: "Record Info", width: 190 },
  ];

  // Fixed width (px) for the trailing sticky "ACTION" column.
  ACTION_COL_WIDTH = 80;

  // Fixed heights (px) of the two sticky header rows. The label row and the
  // filter row use these to compute their sticky `top` offsets, so the three
  // rows stack exactly with no gap or overlap.
  GROUP_ROW_HEIGHT = 30;
  LABEL_ROW_HEIGHT = 32;

  // Deep teal accent — same color used throughout the filter UI.
  ACCENT = "#0f766e";

  // Header colours — subtle tints of the app's navy (#03406f) on neutral greys.
  HEADER_GROUP_BG = "#e6ecf2";
  HEADER_LABEL_BG = "#f5f7f9";
  HEADER_TEXT = "#03406f";
  HEADER_BORDER = "#d3dce5";

  // Filter panel sections. Basic filters are open by default; every other
  // filterable column goes into the collapsed Advanced section.
  BASIC_FILTER_KEYS = [
    "vendorName",
    "erpVendorCode",
    "vendorGstin",
    "vendorPan",
    "collectionDate",
    "collectionReferenceNumber",
    "voucherId",
    "billNumber",
  ];

  // Same value on every row of an entity, so filtering on it is useless.
  FILTER_EXCLUDED_KEYS = ["orgCode"];

  // Columns shown as a dropdown in the filter panel.
  FILTER_DROPDOWN_OPTIONS = {
    nonCashTxnSettlement: ["Y", "N"],
  };

  // Columns shown with a calendar. The calendar works in YYYY-MM-DD and that
  // exact value is sent to the filter api; results are shown as DD-MM-YYYY.
  FILTER_DATE_KEYS = ["collectionDate"];

  toDisplayDate = (v) => {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(v || "");
    return m ? `${m[3]}-${m[2]}-${m[1]}` : v;
  };

  normalizeFilterRecordDates = (records) =>
    (records || []).map((r) => {
      const out = { ...r };
      this.FILTER_DATE_KEYS.forEach((k) => {
        if (out[k]) out[k] = this.toDisplayDate(out[k]);
      });
      return out;
    });

  getBasicFilterColumns = () =>
    this.BASIC_FILTER_KEYS.map((k) =>
      this.filterableColumns.find((c) => c.key === k)
    ).filter(Boolean);

  getAdvancedFilterColumns = () =>
    this.filterableColumns.filter(
      (c) =>
        !this.BASIC_FILTER_KEYS.includes(c.key) &&
        !this.FILTER_EXCLUDED_KEYS.includes(c.key)
    );

  getFieldMeta = (fieldKey) =>
    this.filterableColumns.find((c) => c.key === fieldKey) ||
    this.filterableColumns[0];

  // Every column, filterable or not.
  allColumns = () => [...this.filterableColumns, ...this.nonFilterableColumns];

  // Color band per group.
  GROUP_COLORS = {
    "Vendor": "#0f766e",
    "Payment Details": "#0369a1",
    "Voucher": "#7c3aed",
    "Other": "#1d4ed8",
    "Record Info": "#475569",
  };

  // Distinct groups, in first-seen order, with how many columns each spans
  // — drives the top header row's colSpan per group band.
  getColumnGroups = () => {
    const groups = [];
    this.allColumns().forEach((col) => {
      const existing = groups.find((g) => g.name === col.group);
      if (existing) {
        existing.span += 1;
      } else {
        groups.push({ name: col.group, span: 1 });
      }
    });
    return groups;
  };

  // Total pixel width of every column belonging to a given group — used to
  // size the group-band <th> so it lines up exactly with the columns below it.
  getGroupWidth = (groupName) =>
    this.allColumns()
      .filter((c) => c.group === groupName)
      .reduce((sum, c) => sum + c.width, 0);

  // Sum of every column's width plus the sticky ACTION column — used as the
  // table's min-width so the horizontal scrollbar kicks in instead of the
  // browser squeezing columns to fit.
  getTableMinWidth = () =>
    this.allColumns().reduce((sum, c) => sum + c.width, this.ACTION_COL_WIDTH);

  // Splits a raw string on commas into trimmed, non-empty, de-duplicated
  // values. Used for every field's value box so a person can type or paste
  // "abc ltd, mr.gg, amazon" into one field and match any of them.
  parseBulkFilterValues = (raw) => {
    return Array.from(
      new Set(
        (raw || "")
          .split(",")
          .map((v) => v.trim())
          .filter((v) => v.length > 0)
      )
    );
  };

  handleAutoSyncChange = (checked) => {
    this.setState({ autoSync: checked });
  };

  handlePageChange = (newPage) => {
    console.log('Page change requested:', newPage);
    this.setState({ page: newPage, loading: true }, () => {
      this.uploadReport(this.props.id, newPage, this.state.perPage);
    });
  };


  handleNextPage = (event) => {
    const { errorPage, perErrorPages, errortotal } = this.state;
    const totalPages = Math.ceil(errortotal / perErrorPages);

    if (errorPage < totalPages) {
      const newPage = errorPage + 1;
      console.log(`Navigating to page ${newPage}`);
      this.setState({ errorPage: newPage }, () => {
        // Don't pass ID, let uploadReport get it from localStorage
        this.uploadReport(null, newPage);
      });
    }
  };

  handlePreviousPage = (event) => {
    const { errorPage } = this.state;

    if (errorPage > 1) {
      const newPage = errorPage - 1;
      console.log(`Navigating to page ${newPage}`);
      this.setState({ errorPage: newPage }, () => {
        // Don't pass ID, let uploadReport get it from localStorage
        this.uploadReport(null, newPage);
      });
    }
  };

  handleRowsPerPageChange = (index, value) => {
    console.log(`Changing rows per page to ${value}`);
    this.setState(
      {
        perErrorPages: value,
        errorPage: 1,
      },
      () => {
        // Don't pass ID, let uploadReport get it from localStorage
        this.uploadReport(null, 1);
      }
    );
  };



  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage }, () => {
      if (this.state.appliedFilters.length > 0) {
        this.applyDynamicFilters(
          this.state.appliedFilters,
          this.state.filterMatchType,
          newPage,
          this.state.rowsPerPage
        );
      } else {
        this.sellerCollectionDataGetAPi(null, this.state.searchInput);
      }
    });
  };

  handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = +event.target.value;
    this.setState({ rowsPerPage: newRowsPerPage, page: 0 }, () => {
      if (this.state.appliedFilters.length > 0) {
        this.applyDynamicFilters(
          this.state.appliedFilters,
          this.state.filterMatchType,
          0,
          newRowsPerPage
        );
      } else {
        this.sellerCollectionDataGetAPi(null, this.state.searchInput);
      }
    });
  };
  // table serach
  handleSearchInputChange = (event) => {
    this.setState(
      { searchInput: event.target.value, page: 0, rowsPerPage: 25 },
      () => {
        if (this.state.appliedFilters.length > 0) {
          this.applyDynamicFilters(
            this.state.appliedFilters,
            this.state.filterMatchType,
            0,
            this.state.rowsPerPage
          );
        } else {
          this.sellerCollectionDataGetAPi(null, this.state.searchInput);
        }
      }
    );
  };

  // seller collection get api function
  sellerCollectionDataGetAPi = (event, serachIn) => {
    axios
      .post(`/get_vendor_collection_details`, {
        number_of_rows_per_page: this.state.rowsPerPage,
        page_number: this.state.page,
        search_text: serachIn,
        seller_code: localStorage.getItem("business_entity_id"),
      })
      .then((res) => {
        this.setState({
          allArcCollectionData: res.data.record,
          OriginalAllArcCollectionData: res.data.record,
          rowCount: res?.data?.row_count,
          loader: false,
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          loader: false,
        });
      });
  };

  // Filter API call — takes the { match_type, conditions } payload built by
  // applyDynamicFilters and posts it ONCE for all active conditions, along
  // with pagination, and tracks the currently-applied filters so the
  // page/rowsPerPage handlers can resend them on subsequent pages.
  // If your backend route differs, just change the URL below.
  getVendorCollectionFilterApi = (
    filters = {},
    page = this.state.page,
    rowsPerPage = this.state.rowsPerPage
  ) => {
    this.setState({ loader: true, activeFilters: filters });

    axios
      .post(`/get_vendor_collection_detailsFilter`, {   // ← change URL if your route is different
        seller_code: localStorage.getItem("business_entity_id"),
        search_text: this.state.searchInput || "",
        filters: filters,
        number_of_rows_per_page: rowsPerPage,
        page_number: page,
      })
      .then((res) => {
        this.setState({
          allArcCollectionData: this.normalizeFilterRecordDates(res.data.record || res.data.records),
          OriginalAllArcCollectionData: this.normalizeFilterRecordDates(res.data.record || res.data.records),
          rowCount: res?.data?.row_count || 0,
          loader: false,
          page: page,
          rowsPerPage: rowsPerPage,
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loader: false });
        toast.error("Failed to fetch filtered data");
      });
  };

  // -----------------------------------------------------------------------
  // IN-GRID MULTI-FIELD FILTER
  // -----------------------------------------------------------------------
  // Every filterable column has its own compact box directly in the filter
  // row under the table header. Typing into several boxes at once stages
  // several conditions; nothing is sent to the backend until "Apply" (or
  // Enter) fires ONCE for the whole set.

  // Patches one column's staged (not-yet-applied) value.
  handleInlineFilterChange = (field, rawValue) => {
    this.setState((prevState) => ({
      inlineFilterValues: {
        ...prevState.inlineFilterValues,
        [field]: rawValue,
      },
    }));
  };

  getInlineFilterValue = (field) => this.state.inlineFilterValues[field] ?? "";

  // Clears just one column's box (its little "×" adornment), without
  // touching any other staged column or applying anything.
  clearInlineFilterField = (field) => {
    this.setState((prevState) => ({
      inlineFilterValues: { ...prevState.inlineFilterValues, [field]: "" },
    }));
  };

  // True once at least one column box has something typed into it that
  // hasn't been applied yet — drives the "Apply Filters" affordance.
  hasStagedFilterChanges = () => {
    const { inlineFilterValues, appliedFilters } = this.state;
    const appliedByField = Object.fromEntries(
      appliedFilters.map((c) => [c.field, c.value])
    );
    return this.filterableColumns.some((col) => {
      const staged = (inlineFilterValues[col.key] ?? "").trim();
      const applied = (appliedByField[col.key] ?? "").trim();
      return staged !== applied;
    });
  };

  stagedFilterFieldCount = () =>
    Object.values(this.state.inlineFilterValues).filter(
      (v) => (v ?? "").toString().trim() !== ""
    ).length;

  // Single action: reads every column's box, keeps only the ones with a
  // value, and fires ONE api call for the combined set.
  applyInlineFilters = () => {
    const conditions = this.filterableColumns
      .map((col) => ({
        field: col.key,
        value: (this.state.inlineFilterValues[col.key] ?? "").trim(),
      }))
      .filter((c) => c.value !== "");

    this.setState({ appliedFilters: conditions, page: 0 }, () =>
      this.applyDynamicFilters(
        conditions,
        this.state.filterMatchType,
        0,
        this.state.rowsPerPage
      )
    );
  };

  // Wipes every column's box and whatever was applied, in one shot.
  handleClearAllFilters = () => {
    this.setState(
      { inlineFilterValues: {}, draftValues: {}, appliedFilters: [], page: 0 },
      () =>
        this.applyDynamicFilters([], this.state.filterMatchType, 0, this.state.rowsPerPage)
    );
  };

  // -----------------------------------------------------------------------
  // // COMMON FILTER PANEL — state handlers
  // -----------------------------------------------------------------------

  // The Filter button toggles the panel. When opening, the panel is
  // pre-filled with whatever is currently applied so the person always
  // sees what is live.
  openFilterPanel = () => {
    if (this.state.filterPanelOpen) {
      this.setState({ filterPanelOpen: false });
      return;
    }
    const draftValues = {};
    this.state.appliedFilters.forEach((c) => {
      draftValues[c.field] = c.value;
    });
    this.setState({ filterPanelOpen: true, draftValues });
  };

  // Closing without pressing "Apply Filters" discards unapplied edits.
  closeFilterPanel = () => {
    this.setState({ filterPanelOpen: false });
  };

  toggleAdvancedFilters = () => {
    this.setState((prev) => ({ advancedFiltersOpen: !prev.advancedFiltersOpen }));
  };

  // Chip cross: removes ONE applied filter and reloads the table.
  removeAppliedFilter = (field) => {
    const conditions = this.state.appliedFilters.filter((c) => c.field !== field);
    this.setState(
      (prev) => {
        const draftValues = { ...prev.draftValues };
        delete draftValues[field];
        const inlineFilterValues = { ...prev.inlineFilterValues };
        delete inlineFilterValues[field];
        return { appliedFilters: conditions, draftValues, inlineFilterValues, page: 0 };
      },
      () =>
        this.applyDynamicFilters(
          conditions,
          this.state.filterMatchType,
          0,
          this.state.rowsPerPage
        )
    );
  };

  handleDraftValueChange = (key) => (event) => {
    const value = event.target.value;
    this.setState((prev) => ({
      draftValues: { ...prev.draftValues, [key]: value },
    }));
  };

  // Excel copy-paste brings multiple values separated by newlines (rows) or
  // tabs (columns), with no commas. Convert that shape into the same
  // comma-separated "is any of" format, appending to whatever is typed.
  handleFilterValuePaste = (key) => (e) => {
    const pasted = e.clipboardData.getData("text");
    if (!pasted || !/[\r\n\t]/.test(pasted)) return; // single value — default paste

    e.preventDefault();
    const joined = pasted
      .split(/[\r\n\t]+/)
      .map((v) => v.trim())
      .filter((v) => v.length > 0)
      .join(", ");
    if (!joined) return;

    this.setState((prev) => {
      const current = (prev.draftValues[key] || "").replace(/\s+$/, "");
      const next = !current
        ? joined
        : current.endsWith(",")
        ? `${current} ${joined}`
        : `${current}, ${joined}`;
      return { draftValues: { ...prev.draftValues, [key]: next } };
    });
  };

  // Enter inside any input applies the filter.
  handleFilterKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      this.applyFilterFromPanel();
    }
  };

  // "Apply Filters" — every non-empty input becomes a condition, and the
  // whole set is sent in ONE api call. The panel closes afterwards.
  applyFilterFromPanel = () => {
    const conditions = [
      ...this.getBasicFilterColumns(),
      ...this.getAdvancedFilterColumns(),
    ]
      .map((c) => ({
        field: c.key,
        value: (this.state.draftValues[c.key] || "").trim(),
      }))
      .filter((c) => c.value !== "");

    this.setState(
      { appliedFilters: conditions, filterPanelOpen: false, page: 0 },
      () =>
        this.applyDynamicFilters(
          conditions,
          this.state.filterMatchType,
          0,
          this.state.rowsPerPage
        )
    );
  };

  // Builds the backend payload from the current conditions and either calls
  // the filter API (when conditions exist) or falls back to the normal
  // paginated listing (when the filter set is empty). Every condition is
  // sent as operator "in" — "field value is any of these".
  applyDynamicFilters = (
    conditions = this.state.appliedFilters,
    matchType = this.state.filterMatchType,
    page = 0,
    rowsPerPage = this.state.rowsPerPage
  ) => {
    if (!conditions || conditions.length === 0) {
      this.setState({ activeFilters: null });
      this.sellerCollectionDataGetAPi(null, this.state.searchInput);
      return;
    }

    const payload = conditions.map((c) => ({
      field: c.field,
      operator: "in",
      value: this.parseBulkFilterValues(c.value),
    }));

    const filters = { match_type: matchType, conditions: payload };
    this.setState({ activeFilters: filters });
    this.getVendorCollectionFilterApi(filters, page, rowsPerPage);
  };

  getSellerCollectionLastUploadDate = () => {
    const customer = "Seller Collection";
    axios
      .get(
        `/get_last_update_date/${localStorage.getItem(
          "business_entity_id"
        )}/${customer}`
      )
      .then((res) => {
        const d = res.data.last_updated_date.split("T");
        const Date = indianFormat(d[0]);
        const Time = d[1].split("Z");
        this.setState({
          lastUploadDate: Date,
          lastUploadTime: Time,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getApiForClientID = () => {
    axios
      .get(`/connection_info/${localStorage.getItem("business_entity_id")}`)
      .then((res) => {
        res.data.record
          .filter((v) => v.source_system === "ZOHO")
          .map((value) =>
            localStorage.setItem("Client_ID", value.connection_info.client_id)
          );
        res?.data?.record.filter((v) => {
          if (v.source_system === "Effitrac" || v.source_system === "Tally") {
            localStorage.setItem("Trigger_Effitrac/Tally_Button", "true");
          }
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // getting history table data of upload
  getHistoryTableUploadData = () => {
    axios
      .get(
        `/arc/get_data_upload_history/${localStorage.getItem(
          "business_entity_id"
        )}/${16}`
      )
      .then((res) => {
        this.setState({ uploadHistoryTableData: res.data.record });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getErpConnectorName = () => {
    axios.get(`/arc/verify_erp_data_pull_eligibility/${localStorage.getItem('business_entity_id')}`)
      .then((res) => {
        if (res?.data?.status) {
          this.setState({ erpConnectorName: res?.data?.data })
        }
      }).catch((err) => {

      })
  }

  componentDidMount() {
    let domain = new URL(window.location).searchParams;
    let code = domain.get("code");
    code && this.setState({ grantToken: code });

    let drawer = domain.get("drawer");
    drawer &&
      this.setState({
        openZohoDrawer: true,
        messageForConnection: "Connection Established",
        buttonColor: "green",
      });

    let url = window.location;
    this.setState({ url: url.origin });
    localStorage.setItem("urlOrigin", url.origin);
    localStorage.setItem("pathName", url.pathname);

    this.getApiForClientID();
    this.sellerCollectionDataGetAPi();
    this.getSellerCollectionLastUploadDate();
    this.getHistoryTableUploadData();
    this.getErpConnectorName()
  }

  componentDidUpdate() {
    if (
      this.state.buttonColor === "green" &&
      !this.state.flagForZohoInCollection
    ) {
      this.setState({ flagForZohoInCollection: true });
      variableForTimerForZohoInCollection = setInterval(() => {
        this.setState((prevstate) => ({
          timerForZohoInCollection: prevstate.timerForZohoInCollection - 1,
        }));
      }, 1000);
    }

    if (this.state.timerForZohoInCollection === 0) {
      clearInterval(variableForTimerForZohoInCollection);
      this.setState({
        flagForZohoInCollection: false,
        timerForZohoInCollection: 10,
        buttonColor: "red",
      });
    }
  }

  handleSearchInputChangeForZohoEffitrack = (event) => {
    this.setState({ searchInput: event.target.value }, () => {
      this.globalSearch(event);
    });
  };

  globalSearch = (event) => {
    let { searchInput } = this.state;

    let searchData = this.state.oldEffitracData.filter((value) => {
      const query = searchInput.trim().toLowerCase();
      return (
        String(value.cust_gstin).toLowerCase().indexOf(query) >= 0 ||
        String(value.cust_code).toLowerCase().indexOf(query) >= 0 ||
        String(numberFormat(value.collection_amount))
          .toLowerCase()
          .indexOf(query) >= 0 ||
        String(value.collection_amount).toLowerCase().indexOf(query) >= 0 ||
        String(value.collection_date).indexOf(query) >= 0 ||
        String(value.collection_ref_no).toLowerCase().indexOf(query) >= 0 ||
        String(value.bank_account_no).toLowerCase().indexOf(query) >= 0
      );
    });
    this.setState({ effitracData: searchData });
  };

  fileUploader = (event, serachIn) => {
    this.setState({ loading: true });
    const file_data = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file_data);
    let dis = this;

    reader.onload = function () {
      let file_value = reader.result;
      axios
        .post(`/vendor/vendorcollection`, {
          file: file_value,
          org_code: localStorage.getItem("business_entity_id"),
        })
        .then((data) => {
          if (!data || !data.data) {
            dis.setState({ loading: false });
            return;
          }

          // dis.getHistoryTableUploadData();
          // dis.setState({ loading: false });
          // axios
          //   .post(`/arc/sellerCollection`, {
          //     number_of_rows_per_page: this.state.rowsPerPage,
          //     page_number: this.state.page,
          //     search_text: serachIn,
          //     seller_code: localStorage.getItem("business_entity_id"),
          //   })
          //   .then((res) => {
          //     dis.setState({
          //       allArcCollectionData: res.data.records,
          //       OriginalAllArcCollectionData: res.data.records,
          //       rowCount: res?.data?.row_count,
          //     });
          //   })
          //   .catch((error) => {
          //     console.log(error);
          //   });
        })
        .catch((error) => {
          dis.setState({ loading: false });
          const errorMessage = error?.response?.data?.message;
          if (errorMessage) {
            toast.error(errorMessage, { autoClose: 5000 });
          }
        });
    };
  };

  // refresh Upload History Table using refresh button
  refreshUploadHistoryTable = () => {
    this.getHistoryTableUploadData();
    this.sellerCollectionDataGetAPi();
  };

  CollectionListActions = () => (
    <div>
      <a
        href={SellerCollection}
        download={"vendor_payment.xlsx"}
        style={{ textDecoration: "none" }}
      >
        {" "}
        <Button component="label" size="small" color="primary">
          <GetAppIcon style={{ fontSize: "20px" }} />
          DOWNLOAD TEMPLATE
        </Button>
      </a>
      {canWrite("UPLOADING PURCHASE") && (
      <Button component="label" size="small" color="primary">
        <PublishIcon style={{ fontSize: "20px" }} />
        UPLOAD TEMPLATE{" "}
        <input
          accept=".xlsx"
          name="file"
          type="file"
          value=""
          hidden
          onChange={this.fileUploader}
        />
      </Button>
      )}
      <Button
        component="label"
        size="small"
        color="primary"
        style={{ float: "right" }}
        onClick={this.refreshUploadHistoryTable}
      >
        <RefreshIcon style={{ fontSize: "20px" }} />
        Refresh
      </Button>
    </div>
  );

  // ------------------------------------------ARC collection modal[ customer table] end---------------------------

  // -----------------------------------------------------------------------
  // IN-GRID FILTER — rendering
  // -----------------------------------------------------------------------
  // The slim bar directly above the table. Returns null when there is
  // nothing to show (no applied filters, nothing staged) so it never adds
  // visual weight to the page until it's actually useful.
  renderFilterActionBar = () => {
    const stagedCount = this.stagedFilterFieldCount();
    const hasStaged = this.hasStagedFilterChanges();
    const hasApplied = this.state.appliedFilters.length > 0;

    if (!hasStaged && !hasApplied) return null;

    return (
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "10px",
          padding: "7px 14px",
          marginBottom: "6px",
          borderRadius: "8px",
          background: hasStaged
            ? `linear-gradient(90deg, ${this.ACCENT}, #115e59)`
            : "#f1f5f9",
          color: hasStaged ? "#ffffff" : "#334155",
          transition: "background 0.2s ease",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "10px", fontSize: "12.5px" }}>
          <TuneIcon style={{ fontSize: "16px" }} />
          <span>
            {hasStaged
              ? `${stagedCount} field${stagedCount === 1 ? "" : "s"} ready to filter`
              : `${this.state.appliedFilters.length} filter${
                  this.state.appliedFilters.length === 1 ? "" : "s"
                } active`}
          </span>
        </div>

        <div style={{ display: "flex", gap: "14px", alignItems: "center" }}>
          {hasApplied && (
            <button
              type="button"
              onClick={this.handleClearAllFilters}
              style={{
                background: "transparent",
                border: "none",
                fontSize: "12px",
                cursor: "pointer",
                color: hasStaged ? "rgba(255,255,255,0.9)" : this.ACCENT,
                textDecoration: "underline",
              }}
            >
              Clear all
            </button>
          )}
          {hasStaged && (
            <button
              type="button"
              onClick={this.applyInlineFilters}
              style={{
                background: "#ffffff",
                color: this.ACCENT,
                border: "none",
                borderRadius: "999px",
                padding: "4px 18px",
                fontSize: "12px",
                fontWeight: 700,
                cursor: "pointer",
                boxShadow: "0 1px 4px rgba(0,0,0,0.18)",
              }}
            >
              Apply Filters
            </button>
          )}
        </div>
      </div>
    );
  };

  // -----------------------------------------------------------------------
  // GROUPED HEADER — returns an array of TWO <tr> elements:
  //   1) the colored group-band row, each band spanning all of its columns
  //      via colSpan and sized to the total width of its columns, plus the
  //      trailing ACTION cell which spans both header rows
  //   2) the column-label row
  // The caller drops the array straight into <tbody> (NOT inside another
  // <tr>). Both rows have fixed heights so the sticky offsets of the label
  // row and the filter row stack exactly.
  // -----------------------------------------------------------------------
  arc_collection_TableHeader() {
    const groups = this.getColumnGroups();

    const groupRow = (
      <tr key="group-row">
        {groups.map((g) => {
          const width = this.getGroupWidth(g.name);
          return (
            <th
              key={g.name}
              colSpan={g.span}
              style={{
                position: "sticky",
                top: 0,
                zIndex: 510,
                height: this.GROUP_ROW_HEIGHT,
                lineHeight: "18px",
                width: width,
                minWidth: width,
                maxWidth: width,
                padding: "6px 8px",
                fontSize: "11px",
                fontWeight: 700,
                letterSpacing: "0.4px",
                textTransform: "uppercase",
                color: this.HEADER_TEXT,
                background: this.HEADER_GROUP_BG,
                textAlign: "center",
                borderRight: `1px solid ${this.HEADER_BORDER}`,
                borderBottom: `1px solid ${this.HEADER_BORDER}`,
                whiteSpace: "nowrap",
                boxSizing: "border-box",
              }}
            >
              {g.name}
            </th>
          );
        })}
        <th
          rowSpan={2}
          style={{
            position: "sticky",
            top: 0,
            right: 0,
            zIndex: 520,
            width: this.ACTION_COL_WIDTH,
            minWidth: this.ACTION_COL_WIDTH,
            maxWidth: this.ACTION_COL_WIDTH,
            backgroundColor: this.HEADER_GROUP_BG,
            color: this.HEADER_TEXT,
            fontSize: "11px",
            fontWeight: 700,
            letterSpacing: "0.4px",
            textTransform: "uppercase",
            textAlign: "center",
            verticalAlign: "middle",
            borderLeft: `1px solid ${this.HEADER_BORDER}`,
            borderBottom: `1px solid ${this.HEADER_BORDER}`,
            boxShadow: "-2px 0 4px rgba(0,0,0,0.06)",
            boxSizing: "border-box",
          }}
        >
          ACTION
        </th>
      </tr>
    );

    const labelRow = (
      <tr key="label-row">
        {this.allColumns().map((col) => (
          <th
            key={col.key}
            title={col.label}
            style={{
              position: "sticky",
              top: this.GROUP_ROW_HEIGHT,
              zIndex: 500,
              height: this.LABEL_ROW_HEIGHT,
              lineHeight: "18px",
              width: col.width,
              minWidth: col.width,
              maxWidth: col.width,
              backgroundColor: this.HEADER_LABEL_BG,
              padding: "6px 8px",
              fontSize: "11.5px",
              fontWeight: 600,
              color: "#334155",
              textAlign: "center",
              borderRight: `1px solid ${this.HEADER_BORDER}`,
              borderBottom: `1px solid ${this.HEADER_BORDER}`,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              boxSizing: "border-box",
            }}
          >
            {col.label.toUpperCase()}
          </th>
        ))}
      </tr>
    );

    return [groupRow, labelRow];
  }

  // The filter row itself — lives as a `<tr>` right under the label row,
  // inside the same table, one comma-separated box per filterable column.
  // Pressing Enter in any box applies every staged box at once. The
  // trailing display-only date columns have no filter, so they get plain
  // empty cells, and the cell under ACTION is pinned to the right edge.
  renderInlineFilterRow = () => {
    const filterRowTop = this.GROUP_ROW_HEIGHT + this.LABEL_ROW_HEIGHT;
    const appliedByField = Object.fromEntries(
      this.state.appliedFilters.map((c) => [c.field, c.value])
    );

    return (
      <tr>
        {this.filterableColumns.map((col) => {
          const value = this.getInlineFilterValue(col.key);
          const isApplied =
            value.trim() !== "" && (appliedByField[col.key] ?? "").trim() === value.trim();

          return (
            <td
              key={col.key}
              style={{
                position: "sticky",
                top: filterRowTop,
                zIndex: 400,
                width: col.width,
                minWidth: col.width,
                maxWidth: col.width,
                padding: "6px 10px",
                background: "#f0fdfa",
                borderBottom: `2px solid ${isApplied ? this.ACCENT : "#d9e6e4"}`,
                boxSizing: "border-box",
              }}
            >
              <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                <input
                  type="text"
                  value={value}
                  onChange={(e) => this.handleInlineFilterChange(col.key, e.target.value)}
                  onPaste={(e) => {
                    // Excel copy-paste brings multiple values separated by
                    // newlines (one per row) or tabs (one per column), with
                    // no commas at all. Detect that shape and convert it
                    // into the same comma-separated "is any of" format this
                    // box expects, appending to whatever is already typed.
                    const pasted = e.clipboardData.getData("text");
                    if (!pasted || !/[\r\n\t]/.test(pasted)) return; // plain single-value paste — let default happen

                    e.preventDefault();
                    const pastedValues = pasted
                      .split(/[\r\n\t]+/)
                      .map((v) => v.trim())
                      .filter((v) => v.length > 0);
                    if (pastedValues.length === 0) return;

                    const joined = pastedValues.join(", ");
                    const current = value.replace(/\s+$/, "");
                    const newValue =
                      current === ""
                        ? joined
                        : current.endsWith(",")
                        ? `${current} ${joined}`
                        : `${current}, ${joined}`;

                    this.handleInlineFilterChange(col.key, newValue);
                  }}
                  onKeyDown={(e) => {
                    // Enter applies every staged box at once — same effect
                    // as clicking "Apply Filters" in the bar above.
                    if (e.key === "Enter") {
                      e.preventDefault();
                      this.applyInlineFilters();
                    }
                  }}
                  placeholder={`e.g. ${col.label.toLowerCase()} 1, 2`}
                  style={{
                    width: "100%",
                    border: "none",
                    background: "transparent",
                    outline: "none",
                    fontSize: "12px",
                    fontFamily: "inherit",
                    padding: "3px 18px 3px 2px",
                    color: "#0f172a",
                    textAlign: "center",
                  }}
                />
                {value && (
                  <ClearIcon
                    onClick={() => this.clearInlineFilterField(col.key)}
                    style={{
                      position: "absolute",
                      right: 0,
                      fontSize: "14px",
                      color: "#94a3b8",
                      cursor: "pointer",
                    }}
                  />
                )}
              </div>
            </td>
          );
        })}
        {this.nonFilterableColumns.map((col) => (
          <td
            key={`${col.key}_filter`}
            style={{
              position: "sticky",
              top: filterRowTop,
              zIndex: 400,
              width: col.width,
              minWidth: col.width,
              maxWidth: col.width,
              background: "#f0fdfa",
              borderBottom: "2px solid #d9e6e4",
              boxSizing: "border-box",
            }}
          />
        ))}
        <td
          style={{
            position: "sticky",
            top: filterRowTop,
            right: 0,
            zIndex: 410,
            width: this.ACTION_COL_WIDTH,
            minWidth: this.ACTION_COL_WIDTH,
            maxWidth: this.ACTION_COL_WIDTH,
            padding: "6px 10px",
            background: "#f0fdfa",
            borderBottom: "2px solid #d9e6e4",
            textAlign: "center",
            boxShadow: "-2px 0 4px rgba(0,0,0,0.08)",
            boxSizing: "border-box",
          }}
        >
          {this.state.appliedFilters.length > 0 && (
            <Tooltip title="Clear all filters">
              <IconButton size="small" onClick={this.handleClearAllFilters}>
                <ClearIcon style={{ fontSize: "16px", color: this.ACCENT }} />
              </IconButton>
            </Tooltip>
          )}
        </td>
      </tr>
    );
  };

  // -----------------------------------------------------------------------
  // COMMON FILTER PANEL — rendering
  // -----------------------------------------------------------------------
  renderFilterButton = () => {
    const appliedCount = this.state.appliedFilters.length;
    return (
      <button
        type="button"
        className="button-outlined-primary"
        onClick={this.openFilterPanel}
        style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}
      >
        <FilterAltOutlinedIcon style={{ fontSize: "18px" }} />
        {appliedCount > 0 ? `Filter (${appliedCount})` : "Filter"}
      </button>
    );
  };

  // One label + white input (dropdown for the columns in FILTER_DROPDOWN_OPTIONS).
  renderFilterField = (col) => {
    const { draftValues } = this.state;
    const common = {
      fullWidth: true,
      size: "small",
      variant: "outlined",
      value: draftValues[col.key] ?? "",
      onChange: this.handleDraftValueChange(col.key),
      InputProps: { style: { background: "#fff" } },
    };
    const options = this.FILTER_DROPDOWN_OPTIONS[col.key];

    return (
      <div key={col.key} style={{ minWidth: 0 }}>
        <label style={{ display: "block", fontSize: "12px", marginBottom: "4px" }}>
          {col.label}
        </label>
        {this.FILTER_DATE_KEYS.includes(col.key) ? (
          <ValidatorForm onSubmit={() => {}} style={{ margin: 0 }}>
            <DatePicker
              fullWidth
              name={`filter_${col.key}`}
              placeholder="Select date"
              value={draftValues[col.key] ? moment(draftValues[col.key], "YYYY-MM-DD").toDate() : ""}
              onChange={(v) =>
                this.handleDraftValueChange(col.key)({
                  target: { value: v && moment(v).isValid() ? moment(v).format("YYYY-MM-DD") : "" },
                })
              }
            />
          </ValidatorForm>
        ) : options ? (
          <TextField {...common} select SelectProps={{ native: true }}>
            <option value="">Select</option>
            {options.map((o) => (
              <option key={o} value={o}>
                {o}
              </option>
            ))}
          </TextField>
        ) : (
          <TextField
            {...common}
            placeholder={`Enter ${col.label.toLowerCase()}`}
            onPaste={this.handleFilterValuePaste(col.key)}
            onKeyDown={this.handleFilterKeyDown}
          />
        )}
      </div>
    );
  };

  renderFilterPanel = () => {
    const { filterPanelOpen, draftValues, advancedFiltersOpen } = this.state;
    if (!filterPanelOpen) return null;

    const advancedColumns = this.getAdvancedFilterColumns();
    const advancedCount = advancedColumns.filter(
      (c) => (draftValues[c.key] || "").trim() !== ""
    ).length;

    const gridStyle = {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "12px",
    };

    return (
      <div
        style={{
          width: 440,
          flexShrink: 0,
          display: "flex",
          flexDirection: "column",
          boxSizing: "border-box",
          minHeight: 360,
          // Keeps the panel table-sized; the body scrolls inside.
          maxHeight: "calc(100vh - 260px)",
          border: `1px solid ${this.HEADER_TEXT}`,
          borderRadius: 4,
          background: "#fff",
          overflow: "hidden",
          boxShadow: "0 2px 8px rgba(3,64,111,0.12)",
        }}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "6px 6px 6px 14px",
            background: this.HEADER_TEXT,
            color: "#ffffff",
          }}
        >
          <span style={{ fontSize: "14px", fontWeight: 600 }}>Filters</span>
          <Tooltip title="Close" arrow>
            <IconButton size="small" onClick={this.closeFilterPanel}>
              <ClearIcon style={{ fontSize: "16px", color: "#ffffff" }} />
            </IconButton>
          </Tooltip>
        </div>

        {/* Body: Basic (open) + Advanced (collapsed) */}
        <div
          style={{
            flex: 1,
            minHeight: 0,
            overflowY: "auto",
            padding: "12px 14px",
            background: "#eef3f8",
          }}
        >
          <div
            style={{
              fontSize: "12px",
              fontWeight: 600,
              color: this.HEADER_TEXT,
              marginBottom: "10px",
            }}
          >
            Basic Filters
          </div>
          <div style={gridStyle}>
            {this.getBasicFilterColumns().map((col) => this.renderFilterField(col))}
          </div>

          <div
            role="button"
            onClick={this.toggleAdvancedFilters}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              cursor: "pointer",
              marginTop: "14px",
              padding: "10px 0",
              borderTop: `1px solid ${this.HEADER_BORDER}`,
              fontSize: "12px",
              fontWeight: 600,
              color: this.HEADER_TEXT,
              userSelect: "none",
            }}
          >
            <span>
              {advancedCount > 0
                ? `Advanced Filters (${advancedCount})`
                : "Advanced Filters"}
            </span>
            {advancedFiltersOpen ? (
              <ExpandLessIcon style={{ fontSize: "20px" }} />
            ) : (
              <ExpandMoreIcon style={{ fontSize: "20px" }} />
            )}
          </div>
          {advancedFiltersOpen && (
            <div style={gridStyle}>
              {advancedColumns.map((col) => this.renderFilterField(col))}
            </div>
          )}
        </div>

        {/* Footer — bottom right */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            padding: "10px 14px",
            background: this.HEADER_GROUP_BG,
            borderTop: `1px solid ${this.HEADER_BORDER}`,
          }}
        >
          <button
            type="button"
            className="button-outlined-secondary"
            onClick={this.handleClearAllFilters}
          >
            Clear All
          </button>
          <button
            type="button"
            className="button-primary"
            onClick={this.applyFilterFromPanel}
          >
            Apply Filters
          </button>
        </div>
      </div>
    );
  };

  // Applied filters as small chips, each with its own cross.
  renderAppliedFilterChips = () => {
    const { appliedFilters } = this.state;
    if (appliedFilters.length === 0) return null;

    return (
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "6px",
          marginBottom: "8px",
        }}
      >
        {appliedFilters.map((c) => (
          <Chip
            key={c.field}
            size="small"
            variant="outlined"
            label={`${this.getFieldMeta(c.field).label}: ${
              this.FILTER_DATE_KEYS.includes(c.field) ? this.toDisplayDate(c.value) : c.value
            }`}
            onDelete={() => this.removeAppliedFilter(c.field)}
            style={{
              maxWidth: 280,
              backgroundColor: this.HEADER_GROUP_BG,
              color: this.HEADER_TEXT,
              borderColor: this.HEADER_BORDER,
            }}
          />
        ))}
      </div>
    );
  };

  // table body
  arc_collection__TableData() {
    const editCollectionDrawer = (
      tds_tcs_section,
      voucherId,
      creditLedger,
      group,
      nonCashTxnSettlement,
      billNumber,
      flag,
      modified_date,
      created_date,
    ) => {
      // let collectionDate = dateFormat(collection_date);
      this.setState({
        editCollectionData: {
          tds_tcs_section,
          voucherId,
          creditLedger,
          group,
          nonCashTxnSettlement,
          billNumber,
          flag,
          modified_date,
          created_date,
        },
        editOpenDrawer: true
      });
    };

    console.log(this.state.editCollectionData);

    // Every cell renders as-is (or through the column's own `render`, e.g.
    // currency for Payment Amount), falling back to "-" when empty, so
    // adding or reordering a column in `filterableColumns` /
    // `nonFilterableColumns` is enough to update the header, filter row and
    // body together.
    const renderCellValue = (col, tableData) => {
      const raw = tableData[col.key];
      if (raw === null || raw === undefined || raw === "") return "-";
      return col.render ? col.render(tableData) : raw;
    };

    if (this.state.allArcCollectionData.length >= 1) {
      return this.state.allArcCollectionData.map((tableData, index) => {
        const {
          tds_tcs_section,
          voucherId,
          creditLedger,
          group,
          nonCashTxnSettlement,
          billNumber,
          flag,
          modified_date,
          created_date,
        } = tableData; //destructuring
        return (
          <tr key={index}>
            {this.allColumns().map((col) => {
              const cellValue = renderCellValue(col, tableData);
              return (
                <td
                  key={col.key}
                  title={String(cellValue)}
                  style={{
                    width: col.width,
                    minWidth: col.width,
                    maxWidth: col.width,
                    borderRight: "1px solid #f1f5f9",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    padding: "6px 10px",
                    boxSizing: "border-box",
                    textAlign: "center",
                  }}
                >
                  {cellValue}
                </td>
              );
            })}
            <td
              style={{
                position: "sticky",
                right: 0,
                zIndex: 300,
                width: this.ACTION_COL_WIDTH,
                minWidth: this.ACTION_COL_WIDTH,
                maxWidth: this.ACTION_COL_WIDTH,
                background: "#fff",
                textAlign: "center",
                boxShadow: "-2px 0 4px rgba(0,0,0,0.08)",
                boxSizing: "border-box",
              }}
            >
              <RemoveRedEyeOutlinedIcon
                className="action-icon-button showIcon"
                onClick={() =>
                  editCollectionDrawer(
                    tds_tcs_section,
                    voucherId,
                    creditLedger,
                    group,
                    nonCashTxnSettlement,
                    billNumber,
                    flag,
                    modified_date,
                    created_date,
                  )
                }
              />
            </td>
            {/* <td>{createDate.split(" ")[0]}</td>
            <td>{modifyDate.split(" ")[0]}</td> */}
            {/* <td>
              <Button
                onClick={() =>
                  editCollectionDrawer(
                    cust_code,
                    cust_name,
                    cust_gstin,
                    collection_date,
                    collection_amount,
                    create_date,
                    modify_date,
                    bank_account_number,
                    collection_ref_no
                  )
                }
              >
                Edit
              </Button>
            </td> */}
          </tr>
        );
      });
    } else if (this.state.loader) {
      return (
        <tr>
          <td
            style={{ color: "black", textAlign: "center", fontWeight: "bold" }}
            colSpan={this.allColumns().length + 1}
          >
            Loading...Please wait
          </td>
        </tr>
      );
    } else {
      return (
        <tr>
          <td style={{ color: "red" }} colSpan={this.allColumns().length + 1}>
            {this.state.appliedFilters.length > 0 ? (
              <>
                No records found for the selected filters.{" "}
                <span
                  role="button"
                  onClick={this.handleClearAllFilters}
                  style={{
                    color: this.HEADER_TEXT,
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                >
                  Clear filters
                </span>
              </>
            ) : (
              "No data found!"
            )}
          </td>
        </tr>
      );
    }
  }

  //excel download
  downloadBase64File = (contentType, base64Data, fileName) => {
    const linkSource = `data:${contentType};base64,${base64Data}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  };

  export_to_excel = (datafromfun) => {
  let data = {};
  const businessEntityId = localStorage.getItem("business_entity_id");

  if (!this.state.erpConnectorModelOpen) {
    if (this.state.openZohoDrawer) {
      data = {
        zoho_data: datafromfun,
        business_entity_id: businessEntityId
      };
    } else {
      data = {
        business_entity_id: businessEntityId
      };
    }
  } else {
    data = {
      zoho_data: datafromfun,
      business_entity_id: businessEntityId
    };
  }

  if (this.state.fromPeriod && this.state.toPeriod) {
    data['from_period'] = moment(this.state.fromPeriod).format("YYYY-MM-DD");
    data['to_period'] = moment(this.state.toPeriod).format("YYYY-MM-DD");
  }

  const contentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  const filename = `Vendor Payment.xlsx`;

  axios
    .post("/vendor/vendorcollectiondownload", data)
    .then((res) => {
      this.downloadBase64File(contentType, res.data.file, filename);
    })
    .catch((error) => {
      console.log(error);
    })
    .finally(() => {
      this.setState({ erpDataExportLoading: false });
    });
};

// Export All / Export Filtered (one button). No filters applied -> every
// record, using the same request the existing Export sends with no period.
// Filters applied -> only the records matching them: they are fetched from
// the existing filter api (one page as big as the filtered result) and sent
// to the same download api in `records`, which is the field it reads.
// The download reads each key below directly, so a key missing from the
// filter response is filled with an empty value instead of failing.
VENDOR_PAYMENT_EXTRACT_KEYS = [
  "erpVendorCode", "vendorCode", "vendorName", "vendorGstin", "vendorPan",
  "entityGstin", "branchName", "amountPaid", "collectionDate",
  "collectionReferenceNumber", "bankAccountNumber", "voucherId", "creditLedger",
  "group", "nonCashTxnSettlement", "billNumber", "tds_tcs_section", "flag",
];

exportall_to_excel = () => {
  const contentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  const filename = `Vendor Payment.xlsx`;
  const businessEntityId = localStorage.getItem("business_entity_id");
  const filtered = this.state.appliedFilters.length > 0 && this.state.activeFilters;
  this.setState({ isExportingAll: true });

  const request = filtered
    ? axios
        .post(`/get_vendor_collection_detailsFilter`, {
          seller_code: businessEntityId,
          search_text: this.state.searchInput || "",
          filters: this.state.activeFilters,
          number_of_rows_per_page: Math.max(this.state.rowCount || 0, 1),
          page_number: 0,
        })
        .then((res) => {
          const records = this.normalizeFilterRecordDates(res?.data?.record || res?.data?.records).map((r) => {
            const row = { ...r };
            this.VENDOR_PAYMENT_EXTRACT_KEYS.forEach((k) => {
              if (row[k] === undefined || row[k] === null) row[k] = "";
            });
            return row;
          });
          if (records.length === 0) {
            toast.error("No records found for the selected filters", { autoClose: 2000 });
            return null;
          }
          return axios.post("/vendor/vendorcollectiondownload", {
            business_entity_id: businessEntityId,
            records: records,
          });
        })
    : axios.post("/vendor/vendorcollectiondownload", {
        business_entity_id: businessEntityId,
      });

  request
    .then((res) => {
      if (res) this.downloadBase64File(contentType, res.data.file, filename);
    })
    .catch((error) => {
      console.log(error);
      toast.error(filtered ? "Failed to export filtered data" : "Failed to export all data", { autoClose: 2000 });
    })
    .finally(() => {
      this.setState({ isExportingAll: false });
    });
};

export_erp_data_to_excel = (apPointName, transId) => {
  this.setState({ erpDataExportLoading: true })
   const contentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  const filename = `Vendor Payment.xlsx`;

 const payLoadData = {
      'business_entity_id': localStorage.getItem('business_entity_id'),
      'record_type': apPointName,
      'record_id': transId
    }
  axios.post('/export_erp_connector_data', payLoadData)
    .then((res) => {
      if (res) {
         this.downloadBase64File(contentType, res.data.data, filename);
       
       
      } else {
        toast.error("Data not found. Please try again later.", {
          autoClose: 2000,
        });
        this.setState({ erpDataExportLoading: false }); // <-- FIX
      }
    })
    .catch((err) => {
      toast.error(err?.response?.data?.message || "Error exporting data", {
        autoClose: 2000,
      });
      this.setState({ erpDataExportLoading: false }); // <-- FIX
    })
     .finally(() => {
        this.setState({ erpDataExportLoading: false, isExporting: false });
      })
    
    
};

  // ------------------------edit collection end-----------------------
  closeUploadData = () => {
    this.setState({ showUploadData: false });
    this.sellerCollectionDataGetAPi();
  };

  showToggleDrawerClose = () => {
    this.setState({ showDrawer: false, editOpenDrawer: false });
  };

  // add collection modal
  addCollectionModalOpen = () => {
    this.setState({
      collectionModalBackDrop: true,
    });
  };

  //...............Edited By Harsh Handle Drawer.........
  handleZohoDrawer = () => {
    flagForZoho = 1;
    this.setState({ openZohoDrawer: true });
  };

  closeZohoDrawer = () => {
    clearInterval(variableForTimerForZohoInCollection);
    this.setState({
      zohoDate: {},
      openZohoDrawer: false,
      buttonColor: "red",
      messageForConnection: "Establish Connection",
      grantToken: "",
    });
  };

  // import effitrac / tally form section
  importEffitracTallyOpenDrawer = () => {
    this.setState({ openImportEffitracDrawer: true });
  };

  importFromDateChangeHandler = (v) => {
    const pad = "00";
    const yy = v.getFullYear().toString();
    const mm = (v.getMonth() + 1).toString();
    const dd = v.getDate().toString();

    this.setState((prevState) => ({
      effitracFetchFromData: {
        ...prevState.effitracFetchFromData,
        createdFromDate: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(
          -2
        )}`,
      },
    }));
  };

  importToDateChangeHandler = (v) => {
    const pad = "00";
    const yy = v.getFullYear().toString();
    const mm = (v.getMonth() + 1).toString();
    const dd = v.getDate().toString();

    this.setState((prevState) => ({
      effitracFetchFromData: {
        ...prevState.effitracFetchFromData,
        createdToDate: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`,
      },
    }));
  };

  importModifiedFromDateChangeHandler = (v) => {
    const pad = "00";
    const yy = v.getFullYear().toString();
    const mm = (v.getMonth() + 1).toString();
    const dd = v.getDate().toString();

    this.setState((prevState) => ({
      effitracFetchFromData: {
        ...prevState.effitracFetchFromData,
        modifiedFromDate: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(
          -2
        )}`,
      },
    }));
  };

  importModifiedToDateChangeHandler = (v) => {
    const pad = "00";
    const yy = v.getFullYear().toString();
    const mm = (v.getMonth() + 1).toString();
    const dd = v.getDate().toString();

    this.setState((prevState) => ({
      effitracFetchFromData: {
        ...prevState.effitracFetchFromData,
        modifiedToDate: `${yy}-${(pad + mm).slice(-2)}-${(pad + dd).slice(-2)}`,
      },
    }));
  };

  fetchEffitacFormSubmitHandler = () => {
    this.setState({ effitracFormSubmitLoader: true });
    this.setState((prevState) => ({
      effitracFetchFromData: {
        ...prevState.effitracFetchFromData,
        business_entity_id: localStorage.getItem("business_entity_id"),
      },
    }));
    const data = this.state.effitracFetchFromData;
    axios
      .post("/arc/effitrac/collectionreport", data)
      .then((res) => {
        this.setState({
          isEffitrac: true,
          effitracData: res.data.records.records,
          oldEffitracData: res.data.records.records,
          importEffitracFetchData: {},
          openImportEffitracDrawer: false,
          effitracFormSubmitLoader: false,
        });
      })
      .catch((error) => {
        toast.error(error.response.data.message, {
          autoClose: 2000,
        });
        this.setState({ effitracFormSubmitLoader: false });
      });
  };

  closeEffitracTallyOpenDrawer = () => {
    this.setState({
      openImportEffitracDrawer: false,
      effitracFetchFromData: {},
    });
  };

  closeErpDrawer = () => {
    this.setState({
      erpConnectorModelOpen: false,
    });
  };

  // import to cws button onclick--
  importToCWS = (dataForFun, uploadType = "Zoho", transId) => {
    this.setState({ importToCwsLoading: true })
    let payLoadData = {}
    if (uploadType !== "Zoho") {
      payLoadData = {
        business_entity_id: localStorage.getItem("business_entity_id"),
        records: dataForFun,
        upload_type: uploadType,
        api_point_name: "payment",
        is_import: true,
        record_id: transId,
      }
    } else {
      payLoadData = {
        business_entity_id: localStorage.getItem("business_entity_id"),
        records: dataForFun.map((row, index) => {
          let newRow = { ...row };
          newRow["collectionDate"] = dateFormatWithDash(
            newRow["collectionDate"]
          );

          return newRow;
        }),
      }
    }
    axios
      .post("/arc/effitrac/vendorcollection", payLoadData)
      .then((res) => {
        // this.setState({ showUploadHistroyTable: true });
        this.refreshUploadHistoryTable();
        toast.success("Uploading Files Into Database", {
          autoClose: 5000,
          progress: 0,
        });
      })
      .catch((error) => {
        toast.error("Server error try after same time", {
          autoClose: 5000,
          progress: 0,
        });
      }).finally(() => {
        this.setState({ importToCwsLoading: false })
        this.closeErpDrawer()
      });
  };

  // back button after import effitrac data
  backHandler = () => {
  this.setState({ isEffitrac: false });
};
  establishConnection = (e) => {
    e.preventDefault();
    window.location.href = `https://accounts.zoho.in/oauth/v2/auth?scope=ZohoBooks.fullaccess.READ&client_id=${localStorage.getItem(
      "Client_ID"
    )}&state=testing&response_type=code&redirect_uri=${this.state.url
      }/zohoTesting&access_type=offline&prompt=Consent`;
  };

zohoDateChangeHandler = (item) => {
  const { name, value } = item;

  var d = new Date(value);
  var newd = new Date(d.getTime() - d.getTimezoneOffset() * 60000);
  let dateValue = newd.toISOString().replace("Z", "");

  this.setState((prevState) => ({
    zohoDate: {
      ...prevState.zohoDate,
      [name]: dateValue,
    },
  }));
};

  fetchingdataForZoho = () => {
    clearInterval(variableForTimerForZohoInCollection);
    flagForZoho += 1;

    this.setState({ effitracImportFormloader: true });
    axios
      .post("/arc/zoho_import", {
        business_entity_id: localStorage.getItem("business_entity_id"),
        code: this.state.grantToken,
        type_of_data: "purchase_payment",
        redirect_uri: `${this.state.url}/zohoTesting`,
        date: this.state.zohoDate,
        auto_sync: this.state.autoSync,
      })
      .then((res) => {
        if (res.data.status === true) {
          this.setState({
            zohoDate: {},
            effitracImportFormloader: false,
            buttonColor: "red",
            messageForConnection: "Establish Connection",
            autoSync: false,
            grantToken: "",
          });
        } else {
          this.setState({
            effitracImportFormloader: false,
            zohoDate: {},
            buttonColor: "red",
            messageForConnection: "Establish Connection",
            grantToken: "",
            autoSync: false,
          });
          toast.error(res.data.message, {
            autoClose: 5000,
            progress: 0,
          });
        }
      })
      .catch((err) => {
        this.setState({
          effitracImportFormloader: false,
          zohoDate: {},
          buttonColor: "red",
          messageForConnection: "Establish Connection",
          grantToken: "",
          autoSync: false,
        });
        toast.error(err?.response?.data?.message, {
          autoClose: 5000,
          progress: 0,
        });
      });

  };

  // upload history table show report fn
  // uploadReport = (id) => {
  //   axios
  //     .get(`/arc/get_data_upload_json/${id}`)
  //     .then((response) => {
  //       this.setState({
  //         showUploadData: true,
  //         uploadStatusFail: response.data.records,
  //       });
  //       let res = response.data.records.records;
  //       if (response.data.records.type === "json") {
  //         var error_records = [];
  //         let promises = res.details.map((v, i) => {
  //           if (v.status === "Fail") {
  //             error_records.push(v);
  //           }
  //           return true;
  //         });

  //         Promise.all(promises).then(() => {
  //           this.setState({
  //             total_records: parseInt(res.summary.total_records),
  //             successful_records: parseInt(res.summary.valid_records),
  //             error_records: parseInt(res.summary.invalid_records),
  //             sellerCustomerData: error_records,
  //             error: null,
  //             loading: false,
  //           });
  //           return true;
  //         });
  //       } else {
  //         this.setState({
  //           error: response.data.records.message,
  //           total_records: 0,
  //           loading: false,
  //         });
  //       }
  //     })
  //     .catch((error) => {});
  // };


  uploadReport = (id, pageParam = null) => {
    // Get ID from localStorage if not provided
    let currentId = id;
    if (!currentId) {
      currentId = localStorage.getItem('uploadReportId');
    }

    // If still no ID, show error
    if (!currentId) {
      console.error("uploadReport: Invalid ID", currentId);
      this.setState({ error: "Invalid ID", loading: false });
      return;
    }

    // Store ID in localStorage for future use
    localStorage.setItem('uploadReportId', currentId);

    const page = pageParam !== null ? pageParam : this.state.errorPage;
    const perErrorPages = this.state.perErrorPages || 10;

    if (page < 1 || !Number.isInteger(page)) {
      console.error("uploadReport: Invalid page number", page);
      this.setState({ error: "Invalid page number", loading: false });
      return;
    }

    if (perErrorPages < 1 || !Number.isInteger(perErrorPages)) {
      console.error("uploadReport: Invalid rows per page", perErrorPages);
      this.setState({ error: "Invalid rows per page", loading: false });
      return;
    }

    console.log(`Calling API with id: ${currentId}, page: ${page}, perErrorPages: ${perErrorPages}`);
    console.log(`API URL: /arc/get_data_upload_json/${currentId}/${page}/${perErrorPages}`);

    this.setState({ loading: true, error: null });

    axios
      .get(`/arc/get_data_upload_json/${currentId}/${page}/${perErrorPages}`)
      .then((response) => {
        console.log("API Response:", JSON.stringify(response.data, null, 2));
        const res = response.data.records;

        if (res.type === "json" && res.records && Array.isArray(res.records.details)) {
          const error_records = res.records.details.filter((v) => v.status === "Fail");
          this.setState({
            showUploadData: true,
            uploadStatusFail: res.records,
            total_records: parseInt(res.records.summary?.total_records) || 0,
            successful_records: parseInt(res.records.summary?.valid_records) || 0,
            error_records: parseInt(res.records.summary?.invalid_records) || 0,
            errortotal: parseInt(response.data.total) || 0,
            errorPage: parseInt(response.data.page) || page,
            perErrorPages: parseInt(response.data.per_page) || perErrorPages,
            sellerCustomerData: error_records,
            error: null,
            loading: false,
          });
        } else if (res.type === "message") {
          this.setState({
            showUploadData: true,
            uploadStatusFail: res,
            total_records: 0,
            successful_records: 0,
            error_records: 0,
            errortotal: parseInt(response.data.total) || 0,
            errorPage: parseInt(response.data.page) || page,
            perErrorPages: parseInt(response.data.per_page) || perErrorPages,
            sellerCustomerData: [],
            error: res.message,
            loading: false,
          });
        } else {
          console.warn("Invalid response format:", res);
          this.setState({
            error: "Invalid response format",
            total_records: 0,
            loading: false,
          });
        }
      })
      .catch((error) => {
        console.error("API Error:", error.response || error.message);
        this.setState({
          loading: false,
          error: `Failed to fetch data: ${error.message}`,
        });
      });
  };

  errorLogExportHandlerForUpload = () => {
    // Get the currentId from localStorage
    this.setState({ loadingExport: true });
    let uploadId = localStorage.getItem('uploadReportId');

    let data = {
      business_entity_id: localStorage.getItem("business_entity_id"),
      upload_id: uploadId,
    };

    const contentType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const filename = `vendorCollectionUploadErrorLog.xlsx`;

    axios
      .post(`/uploads_errors_extract/download`, data)
      .then((res) => {
        this.downloadBase64File(contentType, res.data.file, filename);
        this.setState({ loadingExport: true });
      })
      .catch((error) => {
        console.error("Error downloading file:", error);
        this.setState({ loadingExport: true });
      });

  };

  handleErpConnectorButton = () => {
    this.setState({ erpConnectorModelOpen: true })
  }

  handleOpenAndCloseModel = () => {
    this.setState((prevState) => ({
      triggerModelFromToDate: !prevState.triggerModelFromToDate
    }));

  };

  inputHandlerFromDatePicker = (v) => {
    this.setState({ fromPeriodDisplay: v });
    this.setState({ fromPeriod: v })
  };

  inputHandlerToDatePicker = (v) => {
    this.setState({ toPeriodDisplay: v });
    this.setState({ toPeriod: v })
  };

  onSubmitHandlerForDateFilter = () => {

    this.export_to_excel(this.state.allArcCollectionData)

    this.setState({
      dateFilterOption: "withDateFilter",
      triggerModelFromToDate: false,
      fromPeriodDisplay: null,
      fromPeriod: null,
      toPeriodDisplay: '',
      toPeriod: null
    })

  }

  renderDateFilter = () => {
    return (
      <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={this.state.triggerModelFromToDate}
        onHide={this.handleOpenAndCloseModel}
        dialogClassName="modal-50w"
      >
        <Modal.Header closeButton>
          <Modal.Title>Export Vendor Payment</Modal.Title>
        </Modal.Header>
        <ValidatorForm
          useRef="form"
          onSubmit={this.onSubmitHandlerForDateFilter}
          onError={(errors) => console.log(errors)}
        >
          <Modal.Body>
            <Grid container spacing={3}>
              <Grid item sm={12}>
                <FormControl component="fieldset">
                  <RadioGroup
                    row
                    name="dateFilterOption"
                    value={this.state.dateFilterOption}
                    onChange={(e) => this.setState({ dateFilterOption: e.target.value })}
                  >
                    <FormControlLabel
                      value="withDateFilter"
                      control={<Radio />}
                      label="With Date Filter"
                    />
                    <FormControlLabel
                      value="withoutDateFilter"
                      control={<Radio />}
                      label="Without Date Filter"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>

              {this.state.dateFilterOption === "withDateFilter" && (
                <>
                  <Grid item sm={2}>
                    <p style={{ marginTop: "10px", fontSize: "16px" }}>
                      From Date<span style={{ color: "red" }}>*</span>:
                    </p>
                  </Grid>
                  <Grid item sm={4}>
                    <DatePicker
                      maxDate={this.state.toPeriodDisplay ?? ""}
                      placeholder="From Date"
                      errorMessages={["This field is required"]}
                      validators={["required"]}
                      value={this.state.fromPeriodDisplay ?? ""}
                      onChange={(v) => this.inputHandlerFromDatePicker(v)}
                    />
                  </Grid>

                  <Grid item sm={2}>
                    <p style={{ marginTop: "10px", fontSize: "16px" }}>
                      To Date<span style={{ color: "red" }}>*</span>:
                    </p>
                  </Grid>
                  <Grid item sm={4}>
                    <DatePicker
                      minDateForDatepicker={this.state.fromPeriodDisplay ?? ""}
                      placeholder="To Date"
                      errorMessages={["This field is required"]}
                      validators={["required"]}
                      value={this.state.toPeriodDisplay ?? ""}
                      onChange={(v) => this.inputHandlerToDatePicker(v)}
                    />
                  </Grid>
                </>
              )}
            </Grid>
          </Modal.Body>
          <Modal.Footer>
            <button className="button-primary" type="submit">
              Export
            </button>
            <button
              className="button-outlined-secondary"
              type="button"
              onClick={this.handleOpenAndCloseModel}
            >
              Cancel
            </button>
          </Modal.Footer>
        </ValidatorForm>
      </Modal>
    );
  };


  render() {
    return (
      <React.Fragment>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
        <Tooltip title="Back" arrow>
          <IconButton
            onClick={() => this.props.history.push('/Data-Upload')}
            sx={{
              borderRadius: '50%',
              padding: '6px',
              color: '#263238',
              backgroundColor: '#ffffff',
              height: '36px',
              width: '36px',
              '&:hover': {
                backgroundColor: '#455a64',
                color: '#ffffff',
              },
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
              transition: 'background-color 0.3s ease',
            }}
          >
            <ArrowBackIcon sx={{ fontSize: '20px' }} />
          </IconButton>
        </Tooltip>
      </div>

        <ZohoModel
          openZohoDrawer={this.state.openZohoDrawer}
          buttonColor={this.state.buttonColor}
          establishConnection={this.establishConnection}
          messageForConnection={this.state.messageForConnection}
          timerForZohoInSalesCustomer={this.state.timerForZohoInCollection}
          closeZohoDrawer={this.closeZohoDrawer}
          zohoDateChangeHandler={this.zohoDateChangeHandler}
          effitracImportFormloader={this.state.effitracImportFormloader}
          fetchingdataForZoho={this.fetchingdataForZoho}
          zohoDate={this.state.zohoDate}
          logApitName="purchase_payment"
          nameOfTheModel="Payment Data"
          importToCWS={this.importToCWS}
          exportToExcel={this.export_to_excel}
          zohoTableHeader={this.state.effitracHeader}
          zohoTableColumn={this.state.effitracCol}
          drawerKeys={[]}
          autoSync={this.state.autoSync} // Added autoSync prop
          setAutoSync={this.handleAutoSyncChange} // Added setAutoSync prop
        />

        <ErpConnectorModel
          opeErpConnector={this.state.erpConnectorModelOpen}
          closeErpConnector={this.closeErpDrawer}
          logApitName="payment"
          nameOfTheModel="Payment Data"
          importToCWS={this.importToCWS}
          exportToExcel={this.export_erp_data_to_excel}
          ErpTableHeader={this.state.effitracHeader}
          ErpTableColumn={this.state.effitracCol}
          connecotrName={this.state.erpConnectorName}
          erpDataExportLoading={this.state.erpDataExportLoading}
          importToCwsLoading={this.state.importToCwsLoading}
        />

        {/* import Collection effitrac/tally */}
        <RightDrawer
          drawerName="import Effitrac/Tally"
          open={this.state.openImportEffitracDrawer}
          onClose={this.closeEffitracTallyOpenDrawer}
        >
          <ValidatorForm
            ref="form"
            onSubmit={this.fetchEffitacFormSubmitHandler}
            onError={(errors) => console.log(errors)}
          >
            <div style={{ textAlign: "center" }}>
              Last Upload Date<br></br>
              {this.state.lastUploadDate} {this.state.lastUploadTime}
            </div>
            <div style={{ marginTop: "20px" }}>
              <label>Create From Date:</label>
              <ValidatedDatePicker
                fullWidth
                name="fromDate"
                value={this.state.effitracFetchFromData.createdFromDate ?? ""}
                onChange={(v) => this.importFromDateChangeHandler(v)}
              />
            </div>

            <div style={{ marginTop: "20px" }}>
              <label>Create To Date:</label>
              <ValidatedDatePicker
                name="createdToDate"
                value={this.state.effitracFetchFromData.createdToDate ?? ""}
                onChange={(v) => this.importToDateChangeHandler(v)}
              />
            </div>

            <div style={{ marginTop: "20px" }}>
              <label>Modified From Date:</label>
              <ValidatedDatePicker
                name="modifiedFromDate"
                value={this.state.effitracFetchFromData.modifiedFromDate ?? ""}
                onChange={(v) => this.importModifiedFromDateChangeHandler(v)}
              />
            </div>

            <div style={{ marginTop: "20px" }}>
              <label>Modified To Date:</label>
              <ValidatedDatePicker
                name="modifiedToDate"
                value={this.state.effitracFetchFromData.modifiedToDate ?? ""}
                onChange={(v) => this.importModifiedToDateChangeHandler(v)}
              />
            </div>

            {/* submit and back button */}
            <div className="mt-20">
              {this.state.effitracFormSubmitLoader ? (
                <div>
                  <CircularProgress size={22} />
                  <span
                    style={{
                      textTransform: "capitalize",
                      paddingLeft: "10px",
                    }}
                  >
                    Uploading...
                  </span>
                </div>
              ) : (
                <button className="button-primary" type="submit">
                  Submit
                </button>
              )}
              <button
                type="button"
                className="button-outlined-secondary"
                onClick={this.closeEffitracTallyOpenDrawer}
              >
                cancel
              </button>
            </div>
          </ValidatorForm>
        </RightDrawer>

        {/* upload temp Button */}
        {(localStorage.getItem('is_uploads') !== "N") && <>
          {/* <div>
            <div>
              <ToggleSwitch
                onChange={() =>
                  this.setState({
                    showUploadHistroyTable: !this.state.showUploadHistroyTable,
                  })
                }
                value={this.state.showUploadHistroyTable}
                label="Upload Payment"
              />
            </div>
          </div> */}

          {/* File upload history table  */}
          {(localStorage.getItem('is_uploads') !== "N") && (
            <div>
              <BoxWrapper
                boxTitle="Upload Payment History"
                zohoEffitracEnable={
                  localStorage.getItem("Client_ID") &&
                  !this.state.isEffitrac &&
                  canWrite("UPLOADING PURCHASE") &&
                  true
                }
                zohoEffitracFn={this.handleZohoDrawer}
                enableImportToEffTallybutton={
                  localStorage.getItem("Trigger_Effitrac/Tally_Button") &&
                  localStorage.getItem("Trigger_Effitrac/Tally_Button") ===
                  "true" &&
                  !this.state.isEffitrac &&
                  canWrite("UPLOADING PURCHASE")
                }
                importToEffiTallyFn={this.importEffitracTallyOpenDrawer}
                enableAddButton={this.state.erpConnectorName && canWrite("UPLOADING PURCHASE") ? true : false}
                addButtonLabel={this.state.erpConnectorName}
                addButtonHandlerFn={this.handleErpConnectorButton}
              >
                <div style={{ marginBottom: "10px" }}>
                  {" "}
                  <this.CollectionListActions />
                </div>

                <div className="responsive-table">
                  <table className="custome-table">
                    <thead>
                      <tr>
                        <th>Last Upload Date & Time</th>
                        <th>Status</th>
                        <th>Upload Type</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.uploadHistoryTableData.map((item, i) => {
                        return (
                          <tr>
                            <td>{item.upload_date}</td>
                            <td>{item.status}</td>
                            <td>{item.upload_type}</td>
                            <td>
                              {item.status === "In Progress" ? (
                                <RemoveRedEyeOutlinedIcon
                                  className="action-icon-button-disabled"
                                  color="disabled"
                                />
                              ) : item.status === "Uploaded" ? (
                                <RemoveRedEyeOutlinedIcon
                                  className="action-icon-button-disabled"
                                  color="disabled"
                                />
                              ) : (
                                <RemoveRedEyeOutlinedIcon
                                  className="action-icon-button showIcon"
                                  onClick={() => this.uploadReport(item.id)}
                                />
                              )}
                            </td>
                          </tr>
                        );
                      })}
                      {this.state.uploadHistoryTableData.length === 0 && (
                        <tr>
                          <td
                            colspan={4}
                            style={{ color: "red", textAlign: "center" }}
                          >
                            No Data Found!
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </BoxWrapper>
            </div>
          )}
        </>}

        {this.state.showUploadData ? (
          <>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <div className={classes.Main_frame}>
                  <div className={classes.form_title_bar}>
                    <div class="form_title_name">
                      <ul
                        style={{
                          listStyle: "none",
                          marginBottom: "0px",
                          padding: "0px",
                          marginTop: "0px",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <li style={{ fontWeight: "700" }}>Upload Details</li>
                        <li>
                          {this.state.error_records > 0 && (
                            // <button
                            //   className="button-outlined-primary"
                            //   onClick={this.errorLogExportHandlerForUpload}
                            // >
                            //   Export
                            // </button>
                            <button
                              className="button-outlined-primary"
                              onClick={this.errorLogExportHandlerForUpload}
                              disabled={this.state.loadingExport} // Disable button during loading
                            >
                              {this.state.loadingExport ? (
                                <span>Loading...</span> // Simple text loader
                              ) : (
                                <span>Export</span>
                              )}
                            </button>
                          )}

                          <button
                            className="close-icon-button"
                            onClick={this.closeUploadData}
                          >
                            <ClearIcon style={{ color: "var(--app-bar-bg)" }} />
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className={classes.form_body_part}>
                    {this.state.total_records > 0 && (
                      <div>
                        {/* card component */}
                        <div
                          style={{ marginLeft: "30px", marginRight: "30px" }}
                        >
                          <Grid container spacing={3}>
                            <Grid item xs={4}>
                              <Card
                                backgroundcolor="#6f9eaf"
                                cardTitle="Total Records"
                                cardBody={this.state.total_records}
                              />
                            </Grid>
                            <Grid item xs={4}>
                              <Card
                                backgroundcolor="#007965"
                                cardTitle="Successful Records"
                                cardBody={this.state.successful_records}
                              />
                            </Grid>
                            <Grid item xs={4}>
                              <Card
                                backgroundcolor="#eb596e"
                                cardTitle="Error Records"
                                cardBody={this.state.error_records}
                              />
                            </Grid>
                          </Grid>
                        </div>
                        {/* datatable component */}
                        <div
                          style={{
                            height: "300",
                            margin: "20px 30px 0px 30px",
                          }}
                        >
                          <Grid container spacing={3}>
                            <Grid item xs={12}>
                              <div>
                                <MuiThemeProvider>
                                  {/* <DataTables
                                    columns={this.state.sellerCustomerCol}
                                    data={this.state.sellerCustomerData}
                                    selectable={false}
                                    showRowHover={true}
                                    page={1}
                                    count={this.state.total_records}
                                    // showCheckboxes={true}
                                  /> */}
                                  <DataTables
                                    columns={this.state.sellerCustomerCol}
                                    data={this.state.sellerCustomerData}
                                    selectable={false}
                                    page={this.state.errorPage}
                                    count={this.state.errortotal}
                                    rowSize={this.state.perErrorPages}
                                    showRowSizeControls={true}
                                    showFooterToolbar={true}
                                    onNextPageClick={this.handleNextPage}
                                    onPreviousPageClick={this.handlePreviousPage}
                                    onRowSizeChange={this.handleRowsPerPageChange}
                                  />
                                </MuiThemeProvider>
                              </div>
                            </Grid>
                          </Grid>
                        </div>
                      </div>
                    )}
                    {this.state.error && (
                      <div style={{ color: "red" }}>
                        <ErrorIcon />
                        {this.state.error}
                      </div>
                    )}
                  </div>
                </div>
              </Grid>
            </Grid>
          </>
        ) : (
          ""
        )}

        <BoxWrapper
          boxTitle="Payment Details"
          // Filter button inside the BoxWrapper header (see
          // FILTER_BUTTON_IN_BOXWRAPPER at the top of this file)
          headerExtra={
            FILTER_BUTTON_IN_BOXWRAPPER && !this.state.isEffitrac
              ? this.renderFilterButton()
              : null
          }
          // export to excel
          exportToExcelEnable={true}
          exportToExcelFn={this.handleOpenAndCloseModel}
          exportToExcelEnable1={true}
          exportButtonLabel1={this.state.appliedFilters.length > 0 && this.state.activeFilters ? "Export Filtered" : "Export All"}
          exportToExcelFn1={this.exportall_to_excel}
          loadingexcel1={this.state.isExportingAll}
          // search input
          // enableSearchInput={true}
          // searchInputPlaceholder="Search..."
          // searchInputOnchange={
          //   this.state.isEffitrac
          //     ? this.handleSearchInputChangeForZohoEffitrack
          //     : this.handleSearchInputChange
          // }
          // back button
          backButtonForZohoEnable={this.state.isEffitrac}
          backButton={this.backHandler}
          // import to cws button
          importToCwsEnableForZoho={this.state.isEffitrac}
          importToCwsForZoho={this.importToCWS}
        >
          {this.state.isEffitrac ? (
            <CustomTable
              headers={this.state.effitracHeader}
              columns={this.state.effitracCol}
              data={this.state.effitracData}
            />
          ) : (
            <>
              {/* Filter button here only until it is moved into BoxWrapper */}
              {!FILTER_BUTTON_IN_BOXWRAPPER && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginBottom: "8px",
                  }}
                >
                  {this.renderFilterButton()}
                </div>
              )}

              {this.renderAppliedFilterChips()}

              {/* Table on the left, filter panel (when open) on the right —
                  the panel stretches to the table's height. */}
              <div style={{ display: "flex", alignItems: "stretch", gap: "12px" }}>
                <div style={{ flex: 1, minWidth: 0 }}>
                  {/*
                    overflowX: "auto" turns the wide, fixed-width grouped table
                    below into a horizontally-scrolling region instead of
                    letting the browser squeeze the columns to fit.
                  */}
                  <div
                    className="responsive-table"
                    style={{ overflowX: "auto", overflowY: "visible", maxWidth: "100%" }}
                  >
                    <table
                      className="custome-table"
                      style={{
                        borderCollapse: "separate",
                        borderSpacing: 0,
                        minWidth: this.getTableMinWidth(),
                        tableLayout: "fixed",
                        width: "100%",
                      }}
                    >
                      {/* colgroup pins every column to its real width. */}
                      <colgroup>
                        {this.allColumns().map((col) => (
                          <col key={col.key} style={{ width: col.width, minWidth: col.width }} />
                        ))}
                        <col style={{ width: this.ACTION_COL_WIDTH, minWidth: this.ACTION_COL_WIDTH }} />
                      </colgroup>
                      <tbody>
                        {/* Grouped header: returns [groupRow, labelRow] */}
                        {this.arc_collection_TableHeader()}
                        {this.arc_collection__TableData()}
                      </tbody>
                    </table>
                  </div>
                  <TablePagination
                    rowsPerPageOptions={[25, 100, 500, 1000, 3000]}
                    component="div"
                    count={this.state.rowCount} //total row count
                    rowsPerPage={this.state.rowsPerPage}
                    page={this.state.page}
                    onPageChange={this.handleChangePage}
                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                  />
                </div>

                {this.renderFilterPanel()}
              </div>
            </>
          )}
        </BoxWrapper>

        <RightDrawer
          drawerName="Payment Details"
          open={this.state.editOpenDrawer}
          onClose={this.showToggleDrawerClose}
        >
          {Object.keys(this.state.editCollectionData).length && (
            <>
              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="TDS/TCS Section"
                value={this.state.editCollectionData.tds_tcs_section}
              />
              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Voucher ID"
                value={this.state.editCollectionData.voucherId}
              />
              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Credit Ledger"
                value={this.state.editCollectionData.creditLedger}
              />

              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Group"
                value={this.state.editCollectionData.group}
              />

              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Non-cash Txn Settlement(Y/N)"
                value={this.state.editCollectionData.nonCashTxnSettlement}
              />
              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Bill No"
                value={this.state.editCollectionData.billNumber}
              />

              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Flag"
                value={this.state.editCollectionData.flag}
              />
              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Modify Date"
                value={this.state.editCollectionData.modified_date}
              />
              <TextField
                className={classes.showTextField}
                inputProps={{ readOnly: true }}
                fullWidth
                label="Create Date"
                value={this.state.editCollectionData.created_date}
              />
            </>
          )}

          <button
            className="button-outlined-secondary mt-20"
            onClick={this.showToggleDrawerClose}
          >
            close
          </button>
        </RightDrawer>
        {this.renderDateFilter()}
      </React.Fragment>
    );
  }
}

export default withRouter(Collections);